"use client";

import * as React from "react";

import type { PlateElementProps } from "platejs/react";

import { type VariantProps, cva } from "class-variance-authority";
import { PlateElement } from "platejs/react";

const headingVariants = cva(
  "relative mb-1 data-[nav-target=true]:rounded-md data-[nav-target=true]:bg-[var(--highlight)]",
  {
    variants: {
      variant: {
        // Scaled for the pane: its body text is 13px.
        h1: "mt-3 pb-px font-semibold text-lg text-fg first:mt-0",
        h2: "mt-3 pb-px font-semibold text-base text-fg first:mt-0",
        h3: "mt-2.5 font-semibold text-sm text-fg first:mt-0",
        h4: "mt-2 font-semibold text-sm text-fg first:mt-0",
        h5: "mt-2 font-semibold text-sm text-fg-2 first:mt-0",
        h6: "mt-2 font-semibold text-xs text-fg-2 first:mt-0",
      },
    },
  }
);

export function HeadingElement({ variant = "h1", ...props }: PlateElementProps & VariantProps<typeof headingVariants>) {
  return (
    <PlateElement as={variant!} className={headingVariants({ variant })} {...props}>
      {props.children}
    </PlateElement>
  );
}

export function H1Element(props: PlateElementProps) {
  return <HeadingElement variant="h1" {...props} />;
}

export function H2Element(props: PlateElementProps) {
  return <HeadingElement variant="h2" {...props} />;
}

export function H3Element(props: PlateElementProps) {
  return <HeadingElement variant="h3" {...props} />;
}

export function H4Element(props: PlateElementProps) {
  return <HeadingElement variant="h4" {...props} />;
}

export function H5Element(props: PlateElementProps) {
  return <HeadingElement variant="h5" {...props} />;
}

export function H6Element(props: PlateElementProps) {
  return <HeadingElement variant="h6" {...props} />;
}
